<nav class="flex flex-col w-60 h-fit m-4 py-5 px-3 bg-white/70 backdrop-blur-xl rounded-2xl border border-black/[0.06]">
  <!-- Close button for mobile -->
  <button
    class="lg:hidden absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-900 rounded-lg cursor-pointer transition-colors duration-200"
    (click)="closeMenu.emit()"
  >
    <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 18L18 6M6 6l12 12"></path>
    </svg>
  </button>

  <div class="flex flex-col gap-0.5">
    <a
      [routerLink]="['./orders']"
      routerLinkActive="!bg-black/[0.06] !text-gray-900 !font-medium"
      #ordersRla="routerLinkActive"
      class="group flex items-center gap-3 px-3 py-2.5 rounded-[0.625rem] text-[0.9375rem] tracking-tight text-gray-600 no-underline cursor-pointer relative transition-colors duration-200 hover:bg-black/[0.04]"
      (click)="onMenuItemClick()"
    >
      <img src="/library-photo.svg" alt="" class="w-5 h-5 opacity-50 transition-opacity duration-200 group-hover:opacity-70" [class.!opacity-85]="ordersRla.isActive" />
      <span class="flex-1">Orders</span>
      @if (waitingForApprovalCount() > 0) {
        <span
          class="flex items-center justify-center min-w-5 h-5 px-1.5 text-[0.6875rem] font-semibold tracking-wide text-white bg-red-500 rounded-full"
          [class.!bg-gray-900]="ordersRla.isActive"
        >
          {{ waitingForApprovalCount() }}
        </span>
      }
    </a>

    <a
      [routerLink]="['./statistics']"
      routerLinkActive="!bg-black/[0.06] !text-gray-900 !font-medium"
      #statisticsRla="routerLinkActive"
      class="group flex items-center gap-3 px-3 py-2.5 rounded-[0.625rem] text-[0.9375rem] tracking-tight text-gray-600 no-underline cursor-pointer transition-colors duration-200 hover:bg-black/[0.04]"
      (click)="onMenuItemClick()"
    >
      <img src="/stats.svg" alt="" class="w-5 h-5 opacity-50 transition-opacity duration-200 group-hover:opacity-70" [class.!opacity-85]="statisticsRla.isActive" />
      <span class="flex-1">Statistics</span>
    </a>

    <a
      [routerLink]="['./locations']"
      routerLinkActive="!bg-black/[0.06] !text-gray-900 !font-medium"
      #locationsRla="routerLinkActive"
      class="group flex items-center gap-3 px-3 py-2.5 rounded-[0.625rem] text-[0.9375rem] tracking-tight text-gray-600 no-underline cursor-pointer transition-colors duration-200 hover:bg-black/[0.04]"
      (click)="onMenuItemClick()"
    >
      <img src="/location.svg" alt="" class="w-5 h-5 opacity-50 transition-opacity duration-200 group-hover:opacity-70" [class.!opacity-85]="locationsRla.isActive" />
      <span class="flex-1">Locations</span>
    </a>

    <a
      [routerLink]="['./photo-price']"
      routerLinkActive="!bg-black/[0.06] !text-gray-900 !font-medium"
      #priceRla="routerLinkActive"
      class="group flex items-center gap-3 px-3 py-2.5 rounded-[0.625rem] text-[0.9375rem] tracking-tight text-gray-600 no-underline cursor-pointer transition-colors duration-200 hover:bg-black/[0.04]"
      (click)="onMenuItemClick()"
    >
      <img src="/pricetags.svg" alt="" class="w-5 h-5 opacity-50 transition-opacity duration-200 group-hover:opacity-70" [class.!opacity-85]="priceRla.isActive" />
      <span class="flex-1">Photo Price</span>
    </a>

    <a
      [routerLink]="['./customers']"
      routerLinkActive="!bg-black/[0.06] !text-gray-900 !font-medium"
      #customersRla="routerLinkActive"
      class="group flex items-center gap-3 px-3 py-2.5 rounded-[0.625rem] text-[0.9375rem] tracking-tight text-gray-600 no-underline cursor-pointer transition-colors duration-200 hover:bg-black/[0.04]"
      (click)="onMenuItemClick()"
    >
      <img src="/users.svg" alt="" class="w-5 h-5 opacity-50 transition-opacity duration-200 group-hover:opacity-70" [class.!opacity-85]="customersRla.isActive" />
      <span class="flex-1">Customers</span>
    </a>

    <a
      [routerLink]="['./news']"
      routerLinkActive="!bg-black/[0.06] !text-gray-900 !font-medium"
      #newsRla="routerLinkActive"
      class="group flex items-center gap-3 px-3 py-2.5 rounded-[0.625rem] text-[0.9375rem] tracking-tight text-gray-600 no-underline cursor-pointer transition-colors duration-200 hover:bg-black/[0.04]"
      (click)="onMenuItemClick()"
    >
      <img src="/newspaper.svg" alt="" class="w-5 h-5 opacity-50 transition-opacity duration-200 group-hover:opacity-70" [class.!opacity-85]="newsRla.isActive" />
      <span class="flex-1">News</span>
    </a>

    <a
      [routerLink]="['./operators']"
      routerLinkActive="!bg-black/[0.06] !text-gray-900 !font-medium"
      #operatorsRla="routerLinkActive"
      class="group flex items-center gap-3 px-3 py-2.5 rounded-[0.625rem] text-[0.9375rem] tracking-tight text-gray-600 no-underline cursor-pointer transition-colors duration-200 hover:bg-black/[0.04]"
      (click)="onMenuItemClick()"
    >
      <img src="/operators.svg" alt="" class="w-5 h-5 opacity-50 transition-opacity duration-200 group-hover:opacity-70" [class.!opacity-85]="operatorsRla.isActive" />
      <span class="flex-1">Operators</span>
    </a>

    <!-- Separator -->
    <div class="h-px bg-black/[0.06] mx-3 my-2"></div>

    <button
      class="group flex items-center gap-3 px-3 py-2.5 rounded-[0.625rem] text-[0.9375rem] tracking-tight text-gray-400 cursor-pointer w-full text-left border-none bg-transparent transition-colors duration-200 hover:text-red-500 hover:bg-red-500/[0.06]"
      (click)="onLogout()"
    >
      <img src="/shutdown.svg" alt="" class="w-5 h-5 opacity-50 transition-opacity duration-200 group-hover:opacity-80" />
      <span class="flex-1">Logout</span>
    </button>
  </div>
</nav>

@if (showLogoutConfirm()) {
  <app-logout-dialog
    (cancel)="showLogoutConfirm.set(false)"
    (confirm)="confirmLogout()"
  />
}
